const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

/**
 * Tokens provided to this method must declare modal color values as childs like this
 * {
 *  onWhite: { value: "..." },
 *  onDark: { value: "..." },
 * }
 *
 * It can also be a list of tokens like this
 * {
 *  aToken: {
 *    onWhite: { value: "..." },
 *    onDark: { value: "..." },
 *  },
 *  anotherToken: {
 *    onWhite: { value: "..." },
 *    onDark: { value: "..." },
 *  }
 * }
 *
 * The result will have only one value instead of multiple modal choices
 * depending on the mode variable specified
 *
 * @param tokens color token object
 * @param mode dark, white or any other future mode
 **/
export default function getModalValues(tokens: any, mode: string): any {
  const modalProp = `on${capitalize(mode)}`
  if (!tokens) {
    throw new Error('Specified tokens are undefined')
  }

  if (tokens.hasOwnProperty(modalProp)) {
    return tokens[modalProp]
  }
  let ret: any = {}
  for (const name in tokens) {
    ret[name] = tokens[name][modalProp] || tokens[name]
  }
  return ret
}
